module.exports = __webpack_public_path__ + "media/images/pic/brodno/gallery/2021/wigilia/thumbs/5-a27ec3a84708ffd4ad86695c8093d3bd.webp";